import { AnalyticsBrowser } from '@segment/analytics-next'
import { getUser } from 'client/utilities.client-helper'

export const analytics = AnalyticsBrowser.load({
  writeKey: process.env.SEGMENT_TOKEN || ''
})

const identifyUser = async () => {
  const user = getUser()
  const userIdentity = `email:${user.username}`
  await analytics.identify(userIdentity)
}

identifyUser()
  .then(() => {})
  .catch(() => {})
